module.exports = __webpack_public_path__ + "img/img3.4a98acec.jpg";